import { render } from "./Close.vue?vue&type=template&id=0fe5b43b"
const script = {}
script.render = render

export default script